import container from "../../libs/container/container";
import jumpFactory from '../../libs/jump/jump';
import router from '../../libs/router/router';
import {store} from '../../store';

import moduleAboutHeader from '../../module/about/header';
import moduleAboutPurpose from '../../module/about/purpose';
import moduleAboutMission from '../../module/about/mission';
import moduleAboutPartners from '../../module/about/partners';


const amdAboutPage = (function () {
    const name = 'about';

    const view = container.getBaseView(name);

    view.privateVars = {
        itemsKeys: [],
        items: new Map(),
        canNavigateAction: 0,
        targetSection: null,
        currentMenuItem: 'about__header'
    };

    view.service = {
        jump: jumpFactory.create()
    };

    view.startup = function () {

        view.service.jump.init();

        if (view.publicVars.moduleHeaderConfig) {
            view.privateVars.itemsKeys.push('about__header');

            view.privateVars.items.set('about__header', {
                init: false,
                module: moduleAboutHeader,
                config: view.publicVars.moduleHeaderConfig,
                callbacks: {}
            });
        }

        if (view.publicVars.modulePurposeConfig) {
            view.privateVars.itemsKeys.push('about__purpose');

            view.privateVars.items.set('about__purpose', {
                init: false,
                module: moduleAboutPurpose,
                config: view.publicVars.modulePurposeConfig,
                callbacks: {}
            });
        }

        if (view.publicVars.moduleMissionConfig) {
            view.privateVars.itemsKeys.push('about__mission');

            view.privateVars.items.set('about__mission', {
                init: false,
                module: moduleAboutMission,
                config: view.publicVars.moduleMissionConfig,
                callbacks: {}
            });
        }

        if (view.publicVars.modulePartnersConfig) {
            view.privateVars.itemsKeys.push('about__partners');

            view.privateVars.items.set('about__partners', {
                init: false,
                module: moduleAboutPartners,
                config: view.publicVars.modulePartnersConfig,
                callbacks: {}
            });
        }


        if (view.publicVars.startModule !== '' && view.publicVars.startModule !== 'about__header') {
            view.methods.performNavigate(view.publicVars.startModule, {
                slug: view.publicVars.startModuleSlug,
                disableTrack: true,
                fireAnim: 1
            });
        } else {
            view.methods.handleCurrentScrollPosition();
        }

    };

    view.bind = function () {

        let ticking = false;

        // window.addEventListener('beforeunload', function (e) {
        //     if (view.privateVars.currentMenuItem !== 'about__header' && view.privateVars.currentMenuItem !== '') {
        //
        //         let cssHeader = document.querySelector(view.publicVars.cssId.headerCls);
        //
        //         let pos = document.querySelector(view.publicVars.cssId.layout.navigateTargetId + '-' + view.privateVars.currentMenuItem).getBoundingClientRect();
        //
        //         const systemCurrentScroll = document.documentElement.scrollTop || window.scrollY;
        //
        //         window.scrollTo(0, pos.top + systemCurrentScroll - cssHeader.offsetHeight);
        //     }
        // });

        window.addEventListener('scroll', function () {
            if (view.privateVars.canNavigateAction === 0) {
                if (!ticking) {
                    window.requestAnimationFrame(function () {
                        view.methods.handleCurrentScrollPosition();
                        ticking = false;
                    });
                }
                ticking = true;
            }
        });

        window.addEventListener('resize', () => {
            view.methods.handleCurrentScrollPosition();
        });

        window.addEventListener('orientationchange', () => {
            view.methods.handleCurrentScrollPosition();
        });
    };

    view.methods = {
        handleCurrentScrollPosition: (options) => {
            const systemCurrentScroll = document.documentElement.scrollTop || window.scrollY;

            let currentMenu;

            const cssHeader = document.querySelector(view.publicVars.cssId.headerCls);
            const cssHeaderHeight = cssHeader.offsetHeight;

            let continueFindMenuItem = true;
            let lastItemOffsetHeight = 0;

            for (let [key, value] of view.privateVars.items) {

                let cssNavigateTarget = document.querySelector(view.publicVars.cssId.layout.navigateTargetId + '-' + key);

                let targetPos = {
                    top: cssNavigateTarget.getBoundingClientRect().top + window.scrollY,
                    left: cssNavigateTarget.getBoundingClientRect().left + window.scrollX
                };

                view.methods.handleModuleInit(systemCurrentScroll, key, targetPos);

                if (continueFindMenuItem) {
                    if (systemCurrentScroll === 0) {
                        currentMenu = key;
                        continueFindMenuItem = false;
                    } else {
                        let modifier = lastItemOffsetHeight / 2;

                        if ((targetPos.top - cssHeaderHeight - modifier) < systemCurrentScroll) {
                            currentMenu = key;
                        }
                    }
                }

                lastItemOffsetHeight = document.querySelector(view.publicVars.cssId.layout.navigateTargetId + '-' + key).offsetHeight;
            }

            if (options && options.target) {
                currentMenu = options.target;
            }

            if (view.privateVars.currentMenuItem !== currentMenu) {

                view.privateVars.currentMenuItem = currentMenu;
                let metaTitle = document.querySelector(view.publicVars.cssId.layout.navigateTargetId + '-' + currentMenu).dataset['meta.title'];

                let targetUrl = view.publicVars.baseUrl;

                if (view.privateVars.items.get(currentMenu).config.slug) {
                    targetUrl = targetUrl + '/' + view.privateVars.items.get(currentMenu).config.slug;
                }

                let trackAdd = view.publicVars.trackAdd;

                if (currentMenu === 'about__partners') {
                    targetUrl = targetUrl + view.privateVars.items.get(currentMenu).config.slugPartnerDetails + '/' + store.getState().pageAbout.partners.currentTab;
                    metaTitle = store.getState().pageAbout.partners.currentTabMeta;
                    trackAdd.page_name = view.publicVars.trackAdd.page_name + '' + view.privateVars.items.get(currentMenu).config.slugPartnerDetails + '/' + store.getState().pageAbout.partners.currentTab;
                    trackAdd.pageName = trackAdd.page_name;
                    trackAdd.subsection = view.publicVars.trackAddPartners.subsection;
                }

                router.route(targetUrl, metaTitle, { disableTrackForUrl: view.publicVars.currentUrl, trackAdd: trackAdd});
            }
        },

        handleModuleInit: (currentScroll, key, targetPos) => {

            if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {
                const rect = document.querySelector(view.publicVars.cssId.layout.navigateTargetId + '-' + key).getBoundingClientRect();
                const scrollPlusWindowHeight = document.documentElement.clientHeight + currentScroll;

                let specialModifier = 0;
                const cssHeader = document.querySelector(view.publicVars.cssId.headerCls);

                if (cssHeader) {
                    specialModifier = cssHeader.offsetHeight;
                }

                if ((targetPos.top - 200) < scrollPlusWindowHeight &&
                    (scrollPlusWindowHeight < (targetPos.top + rect.height) || currentScroll < (targetPos.top + rect.height + specialModifier))) {

                    view.methods.fireModuleStart(key);

                }
            }

        },

        fireModuleStart: (key) => {
            if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {

                view.privateVars.items.get(key).init = true;
                view.privateVars.items.get(key).module.init(
                    view.privateVars.items.get(key).config,
                    view.privateVars.items.get(key).callbacks
                );
            }
        },

        performNavigate: (target, options) => {

            view.privateVars.targetSection = target;

            view.methods.fireModuleStart(target);

            let easing = (options && options.easing) || 'easeInOutExpo';

            const masterSpeed = (options && options.speed !== undefined && options.speed >= 0) ? options.speed : '';

            const cssHeader = document.querySelector(view.publicVars.cssId.headerCls);
            let modifier = -cssHeader.offsetHeight;

            let speed = 0;

            let shouldFireAnim = (options && options.fireAnim) || 0;

            view.privateVars.canNavigateAction = 1;

            const systemCurrentScroll = document.documentElement.scrollTop;

            let targetPos;

            if (options.detailedJumpTarget) {
                targetPos = document.querySelector(options.detailedJumpTarget).getBoundingClientRect();
            } else {
                targetPos = document.querySelector(view.publicVars.cssId.layout.navigateTargetId + '-' + target).getBoundingClientRect();
            }


            let diff = Math.abs(systemCurrentScroll - targetPos.top);

            if (diff > 1000) {
                speed = 800 + (diff / 3);

            } else {
                speed = 1000;
            }

            container.msg(name, 'diff for navigation ' + diff);

            if (masterSpeed !== '') {
                speed = masterSpeed;
            }

            container.msg(name, 'navigation anim speed ' + speed);

            let jumpTarget;
            let jumpMethod;

            if (options.detailedJumpTarget) {
                jumpTarget = options.detailedJumpTarget;
                jumpMethod = view.service.jump.centerTo;
            } else {
                jumpTarget = view.publicVars.cssId.layout.navigateTargetId + '-' + target;
                jumpMethod = view.service.jump.jumpTo;
            }

            jumpMethod(jumpTarget, {
                modifier: modifier,
                easing: easing,
                speed: speed
            }, function () {

                if (options.finishCallback) {
                    options.finishCallback();
                }

                view.privateVars.canNavigateAction = 0;
                view.privateVars.targetSection = '';

                view.methods.handleCurrentScrollPosition({
                    target
                });
            });
        },
    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

amdAboutPage.init(window.extAboutPageConfig);